export default function GridCanvas() {
  return (
    <div
      aria-hidden="true"
      className="absolute inset-0 w-full h-full"
      data-testid="hero-grid-canvas"
      style={{
        backgroundImage:
          "linear-gradient(to right, rgba(75, 85, 99, 0.14) 1px, transparent 1px), linear-gradient(to bottom, rgba(75, 85, 99, 0.14) 1px, transparent 1px)",
        backgroundSize: "72px 72px",
      }}
    >
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse 55% 45% at 28% 42%, rgba(74, 93, 78, 0.12), transparent 70%)",
        }}
      />
    </div>
  );
}
